import * as zod from 'zod';
import { configureZodCsp } from './configure-zod-csp';

// Import this before application modules so schemas never start the eval probe.
configureZodCsp(zod);
